import Vue from 'vue';

import { get, post } from '../../request';

const state = () => ({
  subscriptions: [],
  error: null,
});

const getters = {
};

const mutations = {
  error(s, e) {
    Vue.set(s, 'error', e);
  },
  setActiveSubscriptions(s, subscriptions) {
    Vue.set(s, 'subscriptions', subscriptions);
  },
};

const actions = {
  async doGetActiveSubscriptions({ commit }) {
    commit('error', null);
    try {
      const data = await get('/user/merchant/active_subscriptions', { commit });
      commit('setActiveSubscriptions', data);
    } catch (e) {
      commit('error', e);
    }
  },
  async doGetCancelSubscription({ commit }, subscription) {
    commit('error', null);
    try {
      const data = await post('/user/merchant/cancel_subscription', {
        subscription_id: subscription.subscription_id,
      }, { commit });
      commit('setActiveSubscriptions', data);
    } catch (e) {
      commit('error', e);
    }
  },
};

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};
